var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "q-toolbar" }, [
    _c(
      "div",
      { staticClass: "q-toolbar-buttons" },
      _vm._l(_vm.model, function (group) {
        return _c(
          "q-button-group",
          { key: group.key },
          _vm._l(group.buttons, function (button) {
            return _c(
              "q-button",
              {
                key: button.key,
                staticClass: "toolbar-button",
                attrs: { size: "mini", type: button.type, plain: button.plain },
                on: {
                  click: function ($event) {
                    return _vm.click(button.key)
                  },
                },
              },
              [
                _c("span", [_vm._v(_vm._s(button.caption))]),
                _vm._v(" "),
                button.icon
                  ? _c("font-awesome-icon", {
                      attrs: { icon: ["fas", button.icon] },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          1
        )
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }